/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { TechniciansEfficientReportResponseDtoPagedListData } from '../models/TechniciansEfficientReportResponseDtoPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { TechniciansEfficientBranchReportResponseDto } from '../models/TechniciansEfficientBranchReportResponseDto';

export class TechniciansEfficientReportService {

  /**
   * @param from 
   * @param to 
   * @param employerName 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @returns TechniciansEfficientReportResponseDtoPagedListData Success
   * @throws ApiError
   */
  public static getTechniciansEfficientReport(
from?: string,
to?: string,
employerName?: string,
branch?: BranchType,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
): CancelablePromise<TechniciansEfficientReportResponseDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technicians-efficient-report',
      query: {
        'From': from,
        'To': to,
        'EmployerName': employerName,
        'Branch': branch,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

    /**
   * @param from 
   * @param to 
   * @returns BranchEfficiencyReport Success
   * @throws ApiError
   */
  public static getTechniciansEfficientReportBranches(
    from?: string,
    to?: string,
  ): CancelablePromise<TechniciansEfficientBranchReportResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technicians-efficient-report/branches',
      query: {
        'From': from,
        'To': to,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

}

